import { Intro } from '@/components/intro';
import { ENTERED_BY_MARKET_NAME } from '@/constants/localstorage';
import { useRegisterToken } from '@/contexts/register-token';
import { ROUTES } from '@/routes';
import { useNavigate, useSearchParams } from 'react-router-dom';

export const NaverRegisterTokenPage = () => {
  const { setNaverToken } = useRegisterToken();
  const [searchParmas] = useSearchParams();

  const navigate = useNavigate();

  localStorage.setItem(ENTERED_BY_MARKET_NAME, 'naver');

  const handleClick = () => {
    //토큰 등록 및 signIn으로 넘어가기
    const token = searchParmas.get('token') ?? '';

    setNaverToken(token);
    navigate(ROUTES.signin, { replace: true });
  };

  return <Intro onStart={handleClick} />;
};
